<template>
  <v-dialog v-model="value" width="500" persistent>
    <v-card>
      <div class="text-xs-right">
        <v-btn flat fab small @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <template v-if="selectedBot.theme == 'universalutilities'">
          <div class="caption">{{ $t('ประปา') }}</div>
          <div v-if="selectedBot.uu_areaname" class="primary--text">
            {{ selectedBot.uu_areaname }}
          </div>
          <template v-else>
            <v-select
              :items="areaname"
              v-model="input.uuAreaName"
              label="ประปา"
              placeholder="ประปา"
              solo
            ></v-select>
          </template>
          <v-layout wrap>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>ชื่อ</label>
                <input v-model="input.uu_name" type="text" />
              </div>
            </v-flex>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>เบอร์โทร</label>
                <input v-model="input.phoneno" type="number" />
              </div>
            </v-flex>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>LineID</label>
                <input v-model="input.search" type="text" />
              </div>
            </v-flex>
            <v-flex sm6>
              <label>{{ $t('Register Status') }}</label>
              <multiselect
                v-model="input.uu_register_status"
                :options="['ลงทะเบียน', 'ไม่ลงทะเบียน']"
                selectLabel
                selectedLabel
                deselect-label
                :placeholder="$t('Register Status')"
              ></multiselect>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation From</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openStartDate"
                      v-model="openStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="input.lastconversationfromdate"
                          v-on="on"
                          clearable
                        />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="input.lastconversationfromdate"
                        @input="openStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openStartTime"
                      v-model="openStartTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationfromtime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      :disabled="input.lastconversationfromdate == null"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-model="input.lastconversationfromtime"
                          v-on="on"
                          :disabled="input.lastconversationfromdate == null"
                        />
                      </template>
                      <v-time-picker
                        v-if="openStartTime"
                        v-model="input.lastconversationfromtime"
                        full-width
                        @click:minute="$refs.openStartTime.save(input.lastconversationfromtime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationfromdate = null
                        input.lastconversationfromtime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation To</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openEndDate"
                      v-model="openEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="input.lastconversationtodate"
                          v-on="on"
                          clearable
                        />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="input.lastconversationtodate"
                        @input="openEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openEndTime"
                      v-model="openEndTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationtotime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="input.lastconversationtodate == null"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-model="input.lastconversationtotime"
                          v-on="on"
                          :disabled="input.lastconversationtodate == null"
                        />
                      </template>
                      <v-time-picker
                        v-if="openEndTime"
                        v-model="input.lastconversationtotime"
                        full-width
                        @click:minute="$refs.openEndTime.save(input.lastconversationtotime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationtodate = null
                        input.lastconversationtotime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </template>
        <template v-if="selectedBot.theme != 'universalutilities'">
          <div class="caption">{{ $t('Search') }}</div>
          <div class="form-control">
            <input type="text" v-model="input.search" :placeholder="$t('Search')" />
          </div>
          <div class="caption">{{ $t('phone no.') }}</div>
          <div class="form-control">
            <input type="text" v-model="input.phoneno" :placeholder="$t('phone no.')" />
          </div>

          <template v-if="selectedBot.theme == 'ustore'">
            <div class="caption">{{ $t('ชื่อ นามสกุล') }}</div>
            <div class="form-control">
              <input type="text" v-model="input.customrealname" :placeholder="$t('ชื่อ นามสกุล')" />
            </div>

            <div class="caption">{{ $t('Email') }}</div>
            <div class="form-control">
              <input type="text" v-model="input.email" :placeholder="$t('Email')" />
            </div>
          </template>

          <div class="caption">{{ $t('Status') }}</div>
          <div class="form-control mb-2">
            <multiselect
              :options="statusOptions"
              v-model="input.status"
              :placeholder="$t('Status')"
              :taggable="true"
              @tag="addStatus"
            >
            </multiselect>
            <!-- <input type="text" v-model="input.status" :placeholder="$t('Status')" /> -->
          </div>
          <div class="caption">{{ $t('Tags') }}</div>
          <multiselect
            :options="tagOptions"
            v-model="input.tags"
            :placeholder="$t('Tags')"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
          >
          </multiselect>
        </template>
        <template v-if="$aston.astonpages.includes($store.state.livechat.pageid)">
          <v-select
            v-model="input.assignadminname"
            :items="computedAstonAdmins"
            outline
            label="Assign to"
            hide-details
            class="mt-4"
            color="primary"
          ></v-select>

          <div class="mt-4">ประเภทลูกค้า</div>
          <v-select
            v-model="input.session"
            :items="$store.state.astonCustomerGroup"
            outline
            label="ประเภทลูกค้า"
            hide-details
            class="mt-1"
            color="primary"
          ></v-select>

          <v-layout class="mt-3">
            <v-flex>
              <div class="form-control">
                <label>Last Conversation From</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openStartDate"
                      v-model="openStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="input.lastconversationfromdate"
                          v-on="on"
                          clearable
                        />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="input.lastconversationfromdate"
                        @input="openStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openStartTime"
                      v-model="openStartTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationfromtime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      :disabled="input.lastconversationfromdate == null"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-model="input.lastconversationfromtime"
                          v-on="on"
                          :disabled="input.lastconversationfromdate == null"
                        />
                      </template>
                      <v-time-picker
                        v-if="openStartTime"
                        v-model="input.lastconversationfromtime"
                        full-width
                        @click:minute="$refs.openStartTime.save(input.lastconversationfromtime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationfromdate = null
                        input.lastconversationfromtime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation To</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openEndDate"
                      v-model="openEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="input.lastconversationtodate"
                          v-on="on"
                          clearable
                        />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="input.lastconversationtodate"
                        @input="openEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openEndTime"
                      v-model="openEndTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationtotime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="input.lastconversationtodate == null"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-model="input.lastconversationtotime"
                          v-on="on"
                          :disabled="input.lastconversationtodate == null"
                        />
                      </template>
                      <v-time-picker
                        v-if="openEndTime"
                        v-model="input.lastconversationtotime"
                        full-width
                        @click:minute="$refs.openEndTime.save(input.lastconversationtotime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationtodate = null
                        input.lastconversationtotime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </template>
        <template v-if="$store.state.rabbitPage.includes(selectedBot.pageid)">
          <!-- RABBIT PAGE -->
          <!-- <div class="form-control mt-2">
            <div>Name</div>

            <input v-model="input.realname" type="text" />
          </div> -->
          <div class="form-control">
            <div>Card number</div>
            <input v-model="input.cardnumber" type="text" />
          </div>
        </template>
        <div v-if="['102549712095297', '105387828535129'].includes(selectedBot.pageid)">
          <div class="caption mt-2">{{ $t('Chat Status') }}</div>
          <Multiselect
            :options="chatstatusOption"
            v-model="input.chatstatus"
            :show-labels="false"
            :multiple="false"
            :searchable="false"
            :allowEmpty="false"
            placeholder="Chat Status"
          ></Multiselect>
        </div>
        <div v-if="selectedBot.type === 'summithr'">
          <div class="caption mt-2">สถานะพนักงาน</div>
          <multiselect
            :options="['active', 'inactive']"
            v-model="input.member_status"
            placeholder="สถานะพนักงาน"
            :multiple="false"
          >
          </multiselect>
        </div>
        <div class="caption mt-2">{{ $t('Channel') }}</div>
        <v-radio-group v-model="tempApp" row>
          <v-radio :label="$t('All')" value="all" color="primary"></v-radio>
          <v-radio :label="'Facebook'" value="facebook" color="primary"></v-radio>
          <v-radio :label="'Line'" value="line" color="primary"></v-radio>
        </v-radio-group>
        <!--
          v-if="
            ['ustore'].includes(selectedBot.theme) ||
              ['102549712095297'].includes(selectedBot.pageid)
          " -->
        <div class="mb-3 form-control">
          <div class="caption">{{ $t('Read status') }}:</div>
          <v-radio-group v-model="input.adminread" row>
            <v-radio :label="$t('All')" :value="null" color="primary"></v-radio>
            <v-radio :label="$t('Read')" value="true" color="primary"></v-radio>
            <v-radio :label="$t('Unread')" value="false" color="primary"></v-radio>
          </v-radio-group>
        </div>
        <div class="mb-3 form-control">
          <div class="caption">{{ $t('Chat type') }}:</div>
          <v-radio-group v-model="input.inbox" row>
            <v-radio :label="$t('All')" value="" color="primary"></v-radio>
            <v-radio :label="$t('Admin')" value="admin" color="primary"></v-radio>
            <v-radio :label="$t('chatbot')" value="bot" color="primary"></v-radio>
          </v-radio-group>
        </div>
        <div class="mb-3 form-control">
          <div class="caption">เวลา</div>
          <date-filter :fullsize="false" :hideSearch="true" v-model="selectedDate"></date-filter>
        </div>
        <v-layout>
          <v-flex class="pa-1">
            <v-btn block depressed @click="clearSearch">
              <v-icon>clear</v-icon>
              {{ $t('Clear All') }}
            </v-btn>
          </v-flex>
          <v-flex class="pa-1">
            <v-btn block depressed @click="onSearch" color="primary">
              <v-icon>search</v-icon>
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import DateFilter from '../dashboard/DateFilter'
import api from '@/api'
export default {
  props: {
    value: {
      default: false
    }
  },
  components: {
    Multiselect,
    DateFilter
  },
  data() {
    return {
      selectedDate: {
        start: null,
        end: null
      },
      chatstatusOption: ['กำลังดำเนินการ', 'ดำเนินการแล้ว', 'ติดตาม'],
      input: {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        session: '',
        assignadminname: '',
        realname: '',
        cardnumber: '',
        chatstatus: '',
        adminread: null,
        email: '',
        inbox: '',
        customrealname: '',
        member_status: ''
      },
      openStartDate: false,
      openEndDate: false,
      openStartTime: false,
      openEndTime: false,
      tagOptions: [],
      statusOptions: [],

      messagesStatusOptions: [
        { text: 'Read', value: true },
        { text: 'Unread', value: false }
      ],
      isClearSearch: false,
      tempApp: 'all'
    }
  },
  async mounted() {},
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    },
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map((el) => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  methods: {
    async loadStatusAndTag() {
      this.getUserTagList()
      this.getUserStatusList()
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        this.tagOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    async getUserStatusList() {
      var response = await api.getUserStatusList()
      if (response && response.result) {
        this.statusOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    clearSearch() {
      this.isClearSearch = true
      this.selectedDate = {
        end: null,
        start: null
      }
      this.input = {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        realname: '',
        cardnumber: '',
        chatstatus: '',
        adminread: null,
        email: '',
        inbox: '',
        customrealname: '',
        member_status: ''
      }
      this.tempApp = 'all'
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        this.input.session = ''
        this.input.assignadminname = ''
      }
      this.onSearch()
    },
    onSearch() {
      let vm = this
      if (vm.input.lastconversationfromdate) {
        vm.input['lastconversationfrom'] =
          vm.input.lastconversationfromdate +
          (vm.input.lastconversationfromtime ? ' ' + vm.input.lastconversationfromtime : ' 00:00')
      } else {
        vm.input['lastconversationfrom'] = null
      }
      if (vm.selectedDate.start && vm.selectedDate.end) {
        vm.input.datefrom = vm.selectedDate.start
        vm.input.dateto = vm.selectedDate.end
      }
      if (vm.input.lastconversationtodate) {
        vm.input['lastconversationto'] =
          vm.input.lastconversationtodate +
          (vm.input.lastconversationtotime ? ' ' + vm.input.lastconversationtotime : ' 23:59')
      } else {
        vm.input['lastconversationto'] = null
      }

      if (vm.isClearSearch && vm.tempApp === 'all') {
        vm.input.app = ''
      } else {
        vm.input.app = vm.tempApp
      }

      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        this.input.adminname = this.input.assignadminname
      }
      vm.$store.commit('SET_LIVECHAT_FILTER', vm.input)

      vm.usersearching = true
      vm.$nextTick(() => {
        vm.$store.dispatch('forceLoadLastestUsers').then(() => {
          vm.usersearching = false
        })
        vm.$emit('input', false)
      })
      vm.isClearSearch = false
    },
    addStatus(newStatus) {
      const status = newStatus
      this.statusOptions.push(status)
      this.input.status = status
    },
    addTag(newTag) {
      const tag = newTag
      // this.tagOptions.push(tag)
      this.input.tags.push(tag)
    }
  },
  watch: {
    async value(newVal) {
      if (newVal) {
        await this.loadStatusAndTag()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatSearch.vue